import { colors } from '../colors'

export const Text = {
  baseStyle: {
    color: colors.gray[500],
    fontFamily: 'body',
    fontStyle: 'normal'
  }
}
